import { isElementNode, isTag } from 'anodum';
import { BREAK_TAG } from '../constants/editable-elements';

const isBreakElement = (element) => {
  if (!isElementNode(element)) return false;

  return isTag(element, BREAK_TAG);
};

export default isBreakElement;
